import React from 'react';
import { Form, Button } from 'react-bootstrap';
import { FaTrash } from 'react-icons/fa';

const TimeSlot = ({ slot, index, onTimeChange, onRemove }) => {
  return (
    <div className="d-flex align-items-center flex-wrap gap-2 mb-2">
      <Form.Control
        type="time"
        value={slot.startTime}
        onChange={(e) => onTimeChange('startTime', e.target.value)}
        size="sm"
        className="flex-grow-1"
        style={{ maxWidth: '120px' }}
      />
      <span className="text-muted fw-bold mx-2" style={{ minWidth: '20px', textAlign: 'center' }}>
        -
      </span>
      <Form.Control
        type="time"
        value={slot.endTime}
        onChange={(e) => onTimeChange('endTime', e.target.value)}
        size="sm"
        className="flex-grow-1"
        style={{ maxWidth: '120px' }}
      />
      <Button
        variant="outline-danger"
        size="sm"
        onClick={onRemove}
        className="flex-shrink-0"
        title="Remove Slot"
      >
        <FaTrash size={12} />
      </Button>
    </div>
  );
};

export default TimeSlot;